import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import {
  AccountBalanceOutlined,
  AccountBalanceWalletOutlined,
  DriveEtaOutlined,
  GavelOutlined,
  HomeOutlined,
  PeopleOutlined,
  PostAddOutlined,
  SettingsOutlined,
} from "@material-ui/icons";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { withRouter } from "react-router";

const useStyles = makeStyles({
  list: {
    width: 250,
    cursor: "pointer",
    textAlign: "left",
  },
  fullList: {
    width: "auto",
  },
  listItem: {
    textAlign: "left",
    color: "black",
  },
});

const MenuDrawer = (props) => {
  const classes = useStyles();
  const { state, toggleDrawer } = props;

  useEffect(() => {
    // Router.events.on('routeChangeStart', onDone);
    // return () => {
    //     Router.events.off('routeChangeStart', onDone)
    // }
  });

  const onDone = () => {
    toggleDrawer("left", false);
  };

  const dataMenu = {
    home: {
      title: "خانه",
      icon: <HomeOutlined />,
      children: null,
      anchor: false,
      setAnchorEl: null,
      url: "/",
    },
    cheque: {
      title: "چک ها",
      icon: <PostAddOutlined />,

      children: [
        {
          title: "افزودن چک",
          url: "/cheque/add",
        },
        {
          title: "لیست",
          url: "/cheque/list/all",
        },
        {
          title: "برگشتی",
          url: "/cheque/list/bounced",
        },
        {
          title: "عودتی ها",
          url: "/cheque/list/returned",
        },
        {
          title: "چک های پیش رو",
          url: "/cheque/list/future",
        },
        {
          title: "پاس شده ها",
          url: "/cheque/list/cashed",
        },
      ],
    },
    cheque_exit: {
      title: " خرید دین",
      icon: <GavelOutlined />,

      children: [
        {
          title: "افزودن خرید دین",
          url: "/cheque-contract/add",
        },
        {
          title: "لیست",
          url: "/cheque-contract/list",
        },
      ],
    },
    car_change: {
      title: " معاملات ماشین",
      icon: <DriveEtaOutlined />,

      children: [
        {
          title: "افزودن معامله ماشین",
          url: "/car-contract/add",
        },
        {
          title: "لیست",
          url: "/car-contract/list",
        },
      ],
    },
    debit_credit: {
      title: " بدهی و طلب",
      icon: <AccountBalanceWalletOutlined />,

      children: [
        {
          title: "افزودن بدهی وطلب",
          url: "/debit-credit/add",
        },
        {
          title: "لیست",
          url: "/debit-credit/list",
        },
      ],
    },
    bank: {
      title: "حساب بانکی",
      icon: <AccountBalanceOutlined />,

      children: [
        {
          title: "افزودن حساب بانکی",
          url: "/bank-account/add",
        },
        {
          title: "لیست",
          url: "/bank-account/list",
        },
      ],
    },

    person: {
      title: " اشخاص",
      icon: <PeopleOutlined />,

      children: [
        {
          title: "افزودن شخص",
          url: "/person/add",
        },
        {
          title: "افزودن مدیر",
          url: "/person/admin/add",
        },
        {
          title: "افزودن حقوقی",
          url: "/legal-entity/add",
        },
        {
          title: "لیست شخص ها",
          url: "/person/list",
        },
        {
          title: "لیست مدیران",
          url: "/person/admin/list",
        },
        {
          title: "لیست حقوقی ها",
          url: "/legal-entity/list",
        },
      ],
    },
    setting: {
      title: "تنظیمات",
      icon: <SettingsOutlined />,
      children: null,
      anchor: false,
      setAnchorEl: null,
      url: "/settings/list",
    },
  };

  const [menuSelect, setMenuSelect] = React.useState(null);

  const sideList = (side) => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
        <ListItem
          button
          key={"برگشت"}
          className={classes.listItem}
          onClick={(e) => toggleDrawer(side, false)}
        >
          <a>
            <ListItemIcon style={{ fontSize: 24, color: "rgba(0,0,0,0.6)" }}>
              <ArrowForwardIcon fontSize={"inherit"} />
            </ListItemIcon>
          </a>
        </ListItem>

        {Object.keys(dataMenu).map((menuName, index) => {
          let d = dataMenu[menuName];
          return (
            <Wrapper>
              <a
                onClick={(e) => {
                  if (d.children) {
                    setMenuSelect(menuSelect == index ? null : index);
                    e.stopPropagation();
                  } else {
                    toggleDrawer(side, false);
                    props.history.push(d.url);
                  }
                }}
              >
                <ListItem key={d.title} className={classes.listItem}>
                  <ListItemIcon>{d.icon}</ListItemIcon>
                  <ListItemText primary={d.title} />
                </ListItem>
              </a>
              {d.children && menuSelect == index
                ? d.children.map((zirMenu) => {
                    return (
                      <ListItem
                        onClick={(e) => {
                          toggleDrawer(side, false);
                          props.history.push(zirMenu.url);
                        }}
                      >
                        <ListItemText primary={zirMenu.title} />
                      </ListItem>
                    );
                  })
                : ""}

              <ListItem divider={true} />
            </Wrapper>
          );
        })}
      </List>
      <div></div>
    </div>
  );

  return (
    <div>
      <Drawer
        anchor="left"
        open={state.left}
        onClose={toggleDrawer("left", false)}
      >
        {sideList("left")}
      </Drawer>
    </div>
  );
};

export default withRouter(MenuDrawer);
